var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1875 13.125C16.9137 13.125 17.5 13.7112 17.5 14.4375C17.5 15.1637 16.9137 15.75 16.1875 15.75H11.8125C11.0863 15.75 10.5 15.1637 10.5 14.4375C10.5 13.7112 11.0863 13.125 11.8125 13.125H16.1875ZM8.3125 6.125C9.03875 6.125 9.625 6.71125 9.625 7.4375C9.625 8.16375 9.03875 8.75 8.3125 8.75H3.9375C3.21125 8.75 2.625 8.16375 2.625 7.4375C2.625 6.71125 3.21125 6.125 3.9375 6.125H8.3125Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 11.375C6.7025 11.375 7.875 12.5475 7.875 14C7.875 15.4525 6.7025 16.625 5.25 16.625C3.7975 16.625 2.625 15.4525 2.625 14C2.625 12.5475 3.7975 11.375 5.25 11.375ZM14.875 4.375C16.3275 4.375 17.5 5.5475 17.5 7C17.5 8.4525 16.3275 9.625 14.875 9.625C13.4225 9.625 12.25 8.4525 12.25 7C12.25 5.5475 13.4225 4.375 14.875 4.375Z",
    fill: "#6C757D"
  })));
}

export default SvgSortIcon;